import Analytics from '@/mixins/Analytics';
import importFederation from './importFederation';

// Remotes that expose ./featureFlagSlugs
const REMOTES_WITH_FEATURE_FLAG_SLUGS = [
  'capital',
  'inventory',
  'offersPortal',
  'panda',
  'sellerControlRoom',
];

// analytic errors on mfe slug import failures
const SLUG_IMPORT_ERRORS = {
  capital: 'CAPITAL FEATURE FLAG SLUGS FAILED',
  inventory: 'My Inventory MFE feature flags failed',
  offersPortal: 'Offers Portal feature flags failed',
  panda: 'Panda feature flags failed',
  sellerControlRoom: 'Seller Control Room feature flags failed',
};

// Loads every remote featureFlagSlugs in parallel
// On error, handle the analytics error and return an empty object
const importRemoteFeatureFlagSlugs = async () => {
  const remoteSlugs = await Promise.all(
    REMOTES_WITH_FEATURE_FLAG_SLUGS.map((remote) => importFederation(`${remote}/featureFlagSlugs`)
      .then((module) => module.default)
      .catch((error) => {
        Analytics.methods.noticeError(SLUG_IMPORT_ERRORS[remote], error);
        return {};
      })),
  );

  // aggregator to one object
  return Object.assign({}, ...remoteSlugs);
};

export default importRemoteFeatureFlagSlugs;
